import React from "react";
import { assets } from "../../../../assets/assets";
import { IDoctor } from "../../../../dto/interfaces";

interface DoctorProfileParams {
    doctor: IDoctor;
}

const Footer: React.FC<DoctorProfileParams> = ({ doctor }) => {
    const clinicName = doctor?.clinicName || "Health Clinic";
    return (
        <footer className="bg-white border-t border-gray-200">
            <div className="container mx-auto px-6 py-6">
                <div className="flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-sm text-gray-600 text-center md:text-left">
                        {" "}
                        © {new Date().getFullYear()} {clinicName}. All rights reserved.
                    </p>
                    <div className="flex items-center justify-center text-gray-500 text-sm gap-2">
                        <span>Powered by</span>
                        <img src={assets.logo} alt="Platform Logo" className="h-6 w-auto" />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
